import React, { useId } from 'react';
import forwardRef from '../../../private/forwardRef';
import { IconProps } from '../icon.types';

const ListMd = forwardRef<IconProps, 'svg'>(({ className, ...props }, ref) => {
    const autoTitleId = useId();
    const titleId = props?.id ? `${props.id}-title` : autoTitleId;
    return (
        <svg
            className={['Nitty__Icon--md', className].filter(Boolean).join(' ')}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            aria-labelledby={props?.title ? titleId : undefined}
            {...props}
        >
            {props?.title && <title id={titleId}>{props.title}</title>}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
            />
        </svg>
    );
});

ListMd.displayName = 'ListMd';

export default ListMd;
